// Sélecteur pour le bouton de filtrage des tailles
const filterSizeButtonClass = ".filtersDesktop__values__wrapper li .js-filterItem";

// -------------------------
// -------------------------
// Attend que le bouton de filtrage des tailles soit prêt
// -------------------------
// -------------------------
setTimeout(function () {
  waitForElm(filterSizeButtonClass).then((elm) => {
    const filterSizeButton = document.querySelector(".js-filterRefinementId_size");
    const sizeTarget = filterSizeButton
      .closest("div")
      .querySelector(".filtersDesktop__values");
    const filtersContent = sizeTarget.innerHTML;

    // Crée un clone des filtres pour l'intégrer dans une nouvelle zone
    const topExperienceArea = document.querySelector(".experience-top");
    const newFiltersClone = document.createElement("div");
    newFiltersClone.classList.add("filters-clone");
    newFiltersClone.innerHTML = filtersContent;

    // Ajoute des ID aux filtres pour les rendre uniques
    const filterNames = newFiltersClone.querySelectorAll("p.caption-02");
    filterNames.forEach((filterName) => {
      const filterNameHtml = filterName.innerHTML;
      const filterNameClass = filterNameHtml.replace(/ /g, "-").toLowerCase();
      const filterNameParentLi = filterName.closest("li");
      filterNameParentLi.id = filterNameClass;

      // Active certains filtres spécifiques
      // if (filterNameParentLi.id === 'bonnet-c' || filterNameParentLi.id === 'körbchen-c') {
      //       filterNameParentLi.classList.add('active');
      // }
    });

    // newFiltersClone.querySelectorAll("li").forEach((itemBtn) => {
    //   itemBtn.classList.add("disabled");
    // });


    // -------------------------
    // -------------------------
    // Gère le comportement des menus déroulants
    // -------------------------
    // -------------------------

    const dropDowns = Array.from(
      newFiltersClone.querySelectorAll("p.caption-02")
    );
    const dropLiDowns = Array.from(
      newFiltersClone.querySelectorAll(".filtersDesktop__values__wrapper li")
    );

    const handleClick = (e) => {
      e.preventDefault();
      dropDowns.forEach((node) => {
        node.closest("li").classList.remove("active");
      });
      e.currentTarget.closest("li").classList.add("active");

      const filterTop = document.querySelector(".filters-clone").offsetTop;
      window.scrollTo({
        top: 100, // Position en pixels depuis le haut
        behavior: "smooth", // Défilement fluide
      });

      const activeSizeElement = e.currentTarget.closest("li").querySelector(".-size");
      const filterHeight = activeSizeElement ? activeSizeElement.offsetHeight : 0;
      document.documentElement.style.setProperty(
        "--filterHeight",
        `${filterHeight}px`
      );

      let activeValue = document.querySelector(".active .values");
      if (activeValue) {
        let valueHeight = activeValue.offsetHeight;
        document.documentElement.style.setProperty(
          "--valueHeight",
          `${valueHeight}px`
        );
      }

      console.log("Dynamic height");

      // -------------------------
      // JavaScript to calculate and assign the height to the CSS variable
      // -------------------------
      let dynamicElement = document.querySelector(".active .values.content");

      if (dynamicElement) {
        const height = dynamicElement.offsetHeight; // Get the height of the target element
        document.documentElement.style.setProperty(
          "--dynamic-height",
          `${height}px`
        );
      }
    };

    dropLiDowns.forEach((node) => {
      node.addEventListener("click", handleClick);
    });

    // -------------------------
    // Définit le premier élément comme actif s'il n'y en a pas
    // -------------------------
    const contenantNb = newFiltersClone.querySelectorAll(
      ".filtersDesktop__values__wrapper ul.values"
    );

    if (contenantNb.length === 1) {
      newFiltersClone.classList.add("oneElement");

      const firstItem = newFiltersClone.querySelector(
        ".filtersDesktop__values__wrapper li:first-child"
      );
      if (firstItem) {
        firstItem.classList.add("active");

        const filterHeight = firstItem.querySelector(".-size").offsetHeight;
        document.documentElement.style.setProperty(
          "--filterHeight",
          `${filterHeight}px`
        );

        const body04Element = firstItem.querySelector(".caption-02");
        if (body04Element) {
          body04Element.style.display = "none";
        }
      }
    }

    // -------------------------
    // Ajoute des classes spécifiques en fonction du nombre de filtres
    // -------------------------
    const numberFilter = newFiltersClone.querySelector(
      ".filtersDesktop__values__wrapper > ul"
    ).childElementCount;
    if (numberFilter >= 8) {
      newFiltersClone.classList.add("very-small-text");
    } else if (numberFilter >= 6) {
      newFiltersClone.classList.add("smaller-text");
    } else if (numberFilter >= 3) {
      newFiltersClone.classList.add("small-text");
    }

    topExperienceArea.append(newFiltersClone);

    // -------------------------
    // Ajoute des classes supplémentaires pour le style
    // -------------------------
    const filterHolders = document.querySelectorAll(".filters-clone .-size");
    filterHolders.forEach((filterHolder) => {
      filterHolder.classList.add("capsule", "freescroll", "stop-anim");
    });

    let filterHeight = 0;

    // -------------------------
    // Met à jour la hauteur du filtre actif
    // -------------------------
    if (document.querySelector(".filters-clone li.active .-size")) {
      filterHeight = document.querySelector(
        ".filters-clone li.active .-size"
      ).offsetHeight;
    } else {
      filterHeight = "50";
    }
    document.documentElement.style.setProperty(
      "--filterHeight",
      `${filterHeight}px`
    );

    let filtersWrapper = document.querySelector(
      ".filtersDesktop__values__wrapper"
    );

    if (filtersWrapper) {
      let bannerHeight = filtersWrapper.offsetHeight;
      document.documentElement.style.setProperty(
        "--bannerHeight",
        `${bannerHeight}px`
      );
    }

    updateCloneElements();
  });
}, 1500);

// -------------------------
// -------------------------
// Configuration et observation des changements dans la section des filtres
// -------------------------
// -------------------------
waitForElm(".filterBar").then(() => {
  const target2 = document.querySelector(".filterBar");

  console.log("Mutation filterBar observation");

  if (target2) {
    const observer2 = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          console.log("Mutation added filterBar");
          checkActiveFilter();
        }
      });
    });

    observer2.observe(target2, { childList: true, subtree: true });
  } else {
    console.error("Observer target not found: .filterBar");
  }

  // setTimeout(() => {
  //   document.querySelectorAll(".filters-clone li").forEach((itemBtn) => {
  //     itemBtn.classList.remove("disabled");
  //   });
  // }, 1000);
});

// -------------------------
// -------------------------
// Lecture automatique des vidéos lorsqu'elles sont visibles
// -------------------------
// -------------------------
waitForElm(".experience-top video").then(() => {
  const videosElms = document.querySelectorAll(".experience-top video");
  videosElms.forEach((videoElm) => {
    const touchPlayVideo = () => {
      videoElm.play();
    };
    window.addEventListener("touchstart", touchPlayVideo, { once: true });
    window.addEventListener("scroll", touchPlayVideo, { once: true });
  });
});

// -------------------------
// -------------------------
// Fonction pour mettre à jour les éléments du clone
// -------------------------
// -------------------------
function updateCloneElements() {
  console.log("updateCloneElements");

  var filtersClone = document.querySelector(".filters-clone");

  var filterNames = filtersClone.querySelectorAll("p.caption-02");

  filterNames.forEach(function (filterName) {
    var filterNameHtml = filterName.innerHTML;

    var filterNameClass = filterNameHtml.replace(/ /g, "-").toLowerCase();
    var filterNameParentLi = filterName.closest("li");
    filterNameParentLi.id = filterNameClass;
  });

  var filtersCloneButtons = filtersClone.querySelectorAll(
    ".sizeButton__container"
  );

  filtersCloneButtons.forEach(function (filtersCloneButton) {
    filtersCloneButton.setAttribute("data-href", "");
    filtersCloneButton.setAttribute("data-permalink", "");
    filtersCloneButton.classList.remove("js-obfuscateLink");
    filtersCloneButton.classList.remove("js-filterItem");

    filtersCloneButton.addEventListener("click", function (event) {
      var clickField1 = filtersCloneButton.dataset.click_field_1;
      var clickField2 = filtersCloneButton.dataset.click_field_2;
      var clickField3 = filtersCloneButton.dataset.click_field_3;
      var clickArea = document.querySelector(
        '.filters__desktop .js-filterItem[data-click_field_1="' +
        clickField1 +
        '"][data-click_field_2="' +
        clickField2 +
        '"][data-click_field_3="' +
        clickField3 +
        '"]'
      );

      clickArea.click();
    });
  });

  let dropDowns = Array.from(filtersClone.querySelectorAll("p.caption-02"));
  let dropLiDowns = Array.from(
    filtersClone.querySelectorAll(".filtersDesktop__values__wrapper li")
  );

  const handleClick = (e) => {
    e.preventDefault();
    dropDowns.forEach((node) => {
      node.closest("li").classList.remove("active");
    });
    e.currentTarget.closest("li").classList.add("active");

    var filterTop = document.querySelector(".filters-clone").offsetTop;
    window.scrollTo({
      top: 100, // Position en pixels depuis le haut
      behavior: "smooth", // Défilement fluide
    });

    // var filterHeight = e.currentTarget
    //   .closest("li")
    //   .querySelector(".-size").offsetHeight;
    // document.documentElement.style.setProperty(
    //   "--filterHeight",
    //   `${filterHeight}px`
    // );

    let activeValue = document.querySelector(".active .values");
    if (activeValue) {
      let valueHeight = activeValue.offsetHeight;
      document.documentElement.style.setProperty(
        "--valueHeight",
        `${valueHeight}px`
      );
    }
  };

  dropLiDowns.forEach((node) => {
    node.addEventListener("click", handleClick);
  });

  let filtersWrapper = document.querySelector(
    ".filtersDesktop__values__wrapper"
  );

  if (filtersWrapper) {
    let bannerHeight = filtersWrapper.offsetHeight;
    document.documentElement.style.setProperty(
      "--bannerHeight",
      `${bannerHeight}px`
    );
  }
}

// -------------------------
// -------------------------
// Fonction pour vérifier et mettre à jour l'état actif du filtre
// -------------------------
// -------------------------
function checkActiveFilter() {
  console.log("checkActiveFilter");

  var filterSizeButton = document.querySelector(".js-filterRefinementId_size");

  var sizeTarget = filterSizeButton
    .closest("div")
    .querySelector(".filtersDesktop__values");
  var currentActiveFilterID = document
    .querySelector(".filters-clone .active")
    .getAttribute("id");
  var filtersContent = sizeTarget.innerHTML;
  var filtersClone = document.querySelector(".filters-clone");
  filtersClone.innerHTML = filtersContent;

  updateCloneElements();
  var filterHolders = document.querySelectorAll(".filters-clone .-size");

  filterHolders.forEach(function (filterHolder) {
    filterHolder.classList.add("capsule");
    filterHolder.classList.add("freescroll");
    filterHolder.classList.add("stop-anim");
  });

  if (document.querySelector(".filters-clone #" + currentActiveFilterID)) {
    document
      .querySelector(".filters-clone #" + currentActiveFilterID)
      .classList.add("active");
  }

  if (
    filtersClone.querySelector(".filtersDesktop__values__wrapper li.active")
  ) {
    var filterHeight = filtersClone
      .querySelector(".filtersDesktop__values__wrapper li.active")
      .querySelector(".-size").offsetHeight;
    document.documentElement.style.setProperty(
      "--filterHeight",
      `${filterHeight}px`
    );
  } else {
    filtersClone
      .querySelector(".filtersDesktop__values__wrapper li:first-child")
      .classList.add("active");
    var filterHeight = filtersClone
      .querySelector(".filtersDesktop__values__wrapper li.active")
      .querySelector(".-size").offsetHeight;
    document.documentElement.style.setProperty(
      "--filterHeight",
      `${filterHeight}px`
    );
  }

  var numberFilter = filtersClone.querySelector(
    ".filtersDesktop__values__wrapper > ul"
  ).childElementCount;

  if (numberFilter >= 8) {
    filtersClone.classList.add("very-small-text");
  } else if (8 > numberFilter >= 6) {
    filtersClone.classList.add("smaller-text");
  } else if (6 > numberFilter >= 3) {
    filtersClone.classList.add("small-text");
  }
}

// -------------------------
// -------------------------
// Fonction utilitaire pour attendre qu'un élément spécifique apparaisse dans le DOM
// -------------------------
// -------------------------
function waitForElm(selector) {
  return new Promise((resolve) => {
    // Vérifie si l'élément existe déjà
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    // Observe les mutations du DOM pour détecter l'ajout de l'élément
    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}
